export default "__VITE_ASSET__1d4b245d__"